<lex-case-analytics-item [noDataInCase]="noDataInCase$">
    <div card-header-content-primary  *ngIf="uploadBatchSummary === null && !shouldShowLoader" [@appear]>
        <div>Uploads <span>({{displayedBatchCount}}</span> of <span>{{caseUploadBatchCount}})</span></div>
        <div>{{caseDocCount | number}}</div>
        <div>Documents <b>uploaded</b> to this case</div>
    </div>
    <div card-header-content-primary *ngIf="uploadBatchSummary !== null && !shouldShowLoader" [@appear]>
        <div>{{uploadBatchSummary.batchTitle}}</div>
        <div>
            <b>{{uploadBatchSummary.docCount | number}} </b>
        </div>
        <div>
            <span *ngIf="uploadBatchSummary.docCount === 1">Document</span>
            <span *ngIf="uploadBatchSummary.docCount !== 1">Documents</span>
            in this batch
        </div>
    </div>
    <div card-body-content-chart *ngIf="chartData.datasets.length > 0" [ngClass]="{'loading': shouldShowLoader === true}">
        <canvas
            baseChart
            type="bar"
            [data]="chartData"
            [options]="ngChartOptions"
            [plugins]="ngChartPlugins"
            [legend]="true"
            (chartHover)="displayBatchSummary($event)"
            (chartClick)="selectBatch($event)">
        </canvas>
    </div>
    <div card-body-content-chart *ngIf="shouldShowLoader" style="display: flex; align-items: center; justify-content: center;">
      <i card-body-loading-icon class="fa-light fa-chart-waterfall fa-fade" style="font-size: 19.2vh;"></i>
    </div>
</lex-case-analytics-item>
